import React from 'react';
import { MapPin } from 'lucide-react';
import { BASECAMP } from '../content';
import { SCENE_IMG } from '../media';
import { ContourLines } from './ContourLines';
export function Basecamp() {
  return <section id="basecamp" className="relative overflow-hidden bg-background" aria-labelledby="basecamp-heading" data-id="element-10" data-mp="29nfv415oea13">
      {/* Faint contour lines behind the whole section, like a trail map. */}
      <ContourLines className="pointer-events-none absolute inset-0 h-full w-full" data-id="element-11" data-mp="31e3tj5fyt1b2" />

      <div className="section-shell relative py-16 lg:py-20" data-id="element-12" data-mp="2xdjsvrw6nfk6">
        <p className="overline" data-id="element-13" data-mp="2seqhq64dc0n6">What basecamp gives you</p>
        {/* Vitality convenes; it does not claim to be the expertise. The
            verbs carry the weight, set in the serif italic. Wide measure so it
            sets in three lines across the section rather than a tall column. */}
        <h2 id="basecamp-heading" className="mt-5 max-w-4xl font-serif text-h3 lg:text-h2" data-id="element-14" data-mp="1gx7b03rkxfjv">
          We are your crew. We <em data-id="element-15" data-mp="10ocnzgr0nrwv">find</em> the mentors, experts, and resources you need, and we{' '}
          <em data-id="element-16" data-mp="10m8n77oez90t">bring</em> them to you.
        </h2>

        {/* Steps on the left; the grove on the right is cut to the exact
            height of the steps so both columns share a top and bottom edge. */}
        <div className="mt-12 grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:items-stretch lg:gap-16" data-id="element-17" data-mp="vp01ix424mut">
          {/* Same numbered-list system as before, drawn as a route: a hairline
              trail runs through the waypoints and trails off, dashed, into the
              next stretch. */}
          <ol className="space-y-12 lg:pb-10" data-id="element-18" data-mp="lsnay83t6p4a">
            {BASECAMP.map((item, i) => {
            const first = i === 0;
            const last = i === BASECAMP.length - 1;
            return <li key={item.title} className="grid grid-cols-[1.5rem_2.5rem_1fr] gap-x-3" data-id="element-19" data-mp="3u6m1gu80hiae" data-mpi={i}>
                  {/* Trail + waypoint */}
                  <div className="relative flex justify-center" data-id="element-20" data-mp="2z9jiczb10tf">
                    {first ? <MapPin size={20} strokeWidth={1.5} className="relative z-10 mt-0 text-primary" fill="currentColor" stroke="var(--background)" aria-hidden="true" data-id="element-21" data-mp="3g25aap2qc63r" /> : <span className="relative z-10 mt-[11px] block h-3 w-3 rounded-full border border-border-strong bg-background" aria-hidden="true" data-id="element-22" data-mp="2ujzbom4g4ra" />}
                    <span aria-hidden="true" className={`absolute left-1/2 border-l border-border-strong ${first ? 'top-5' : 'top-7'} ${last ? '-bottom-10 border-dashed' : '-bottom-12'}`} data-id="element-23" data-mp="3p0gykkg4irt1" />
                  </div>

                  <span className={`text-body-sm text-accent-text ${first ? 'pt-0.5' : 'pt-1.5'}`} data-id="element-24" data-mp="28m7cjwzctf5d">
                    0{i + 1}
                  </span>

                  <div data-id="element-25" data-mp="t3sxe3mk3gj8">
                    {first && <p className="overline mb-3" style={{
                  color: 'var(--accent-text)'
                }} data-id="element-26" data-mp="t27zc4119fgm">
                        You are here
                      </p>}
                    <h3 className="font-serif text-h4 leading-snug" data-id="element-27" data-mp="12vov3dkqd4mx">{item.title}</h3>
                    <p className="mt-2 text-body-sm leading-body text-muted-foreground" data-id="element-28" data-mp="17sp1jplhs9ek">{item.body}</p>
                  </div>
                </li>;
          })}
          </ol>

          <figure className="relative m-0 h-56 overflow-hidden rounded-lg lg:h-auto lg:min-h-64" data-id="element-29" data-mp="1gv6lfxdocpye">
            <img src={SCENE_IMG.aspenGrove} alt="An autumn aspen grove, hundreds of pale trunks sharing one root system" loading="lazy" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-30" data-mp="1ls6rw9efruq1" />
          </figure>
        </div>
      </div>
    </section>;
}